export const API_PATH: string = import.meta.env.VITE_API_PATH || "";
export const API_VERSION = "v1";
